import {Component, OnInit} from '@angular/core';
import {Params, ActivatedRoute} from "@angular/router";
import {IMyOptions} from 'mydatepicker';
import {ApiService} from "../services/api.service";
import {DataService} from "../services/data.service";
import {Subscription} from "rxjs";

@Component({
    selector: 'app-company-visa',
    templateUrl: './company-visa.component.html',
})
export class CompanyVisaComponent implements OnInit {
    node = 'company-visa';
    visaStatusNode = 'visa-status';
    //companyNode = 'companies';
    usersNode = 'user';

    clear = '';
    isChecked = false;
    checkedList = [];
    users = [{}];
    visa = {};
    //selectedVisa = {"visa_id": ""};
    visas = [{"visa_id": ""}];
    companyMetaData = {"totalItems": "", "limit": "30", "offset": ""};
    visaStatuses = [{}];
    queryString = 'all';
    value: Date;
    query = {
        "search": "",
        "search_field": "",
        "visa_status_id": "",
        "created_at_start": {"formatted": ""},
        "created_at_end": {"formatted": ""},
        "order_by": "visa_id",
        "order": "desc"
    };

    busy: Subscription;

    display: boolean = false;

    myDatePickerOptions: IMyOptions = {
        // other options...
        dateFormat: 'dd/mm/yyyy',
    };

    constructor(private apiService: ApiService,
                private dataService: DataService,
                private route: ActivatedRoute,) {
    }

    ngOnInit() {
        this.dataService.refresh();
        //get the data
        this.route.params
            .subscribe(
                (params: Params) => {
                    if (params['visa_status_id']) {
                        this.queryString = 'visa_status_id=' + params['visa_status_id'];
                        this.getUsingQuery();
                    } else {
                        this.getUsingQuery();
                    }

                }
            );
        this.getVisaStatuses();
        //this.getCompanyCategories();
        this.getUsers();
    }

    getUsingQuery(): void {
        this.queryString = '&search=' + this.query.search
            + '&search_field=' + this.query.search_field
            + '&visa_status_id=' + this.query.visa_status_id
            // + '&created_at_start=' + ((this.query.created_at_start.formatted != undefined) ? this.query.created_at_start.formatted : '')
            // + '&created_at_end=' + ((this.query.created_at_end.formatted != undefined) ? this.query.created_at_end.formatted : '')
            + '&order_by=' + this.query.order_by
            + '&order=' + this.query.order
            + '&offset=' + this.companyMetaData.offset
            + '&limit=' + this.companyMetaData.limit
        this.apiService.getUsingQuery(this.node, this.queryString)
            .subscribe(
                (response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        this.visas = [{"visa_id": ""}];
                        this.companyMetaData = {"totalItems": "0", "limit": "0", "offset": "0"};
                    } else {
                        this.visas = response.json().data.data;
                        this.companyMetaData = response.json().data.metaData;
                    }
                },
                (error) => {
                    this.visas = [{"visa_id": ""}];
                }
            );
    }

    onDelete() {
        if (confirm('Are you absolutely sure you want to delete?')) {
            this.apiService.delete(this.node, this.checkedList)
                .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        alert('Unable to delete company');
                    } else {
                        this.getUsingQuery();
                        this.isChecked = false;
                        this.checkedList = [];
                        alert('Company Deleted Successfully');
                    }
                });
        }
    }

    getUsers() {
        this.apiService.getAll(this.usersNode)
            .subscribe((response) => {
                this.dataService.updateActiveRequestNo(-1);
                if (response.json().error == true) {
                    this.users = [{}];
                } else {
                    this.users = response.json().data;
                }
            })
    }

    getVisaStatuses() {
        this.apiService.getAll(this.visaStatusNode)
            .subscribe((response) => {
                this.dataService.updateActiveRequestNo(-1);
                if (response.json().error == true) {
                    this.visaStatuses = [{}];
                } else {
                    this.visaStatuses = response.json().data;
                }
            });
    }

    onFormSubmit() {
        this.companyMetaData.offset = "0";
        this.getUsingQuery();
    }

    onPageChange(offset) {
        this.companyMetaData.offset = offset;
        this.getUsingQuery();
    }

    updateCheckList(id) {
        if (this.checkedList.indexOf(id) == -1) {
            this.checkedList.push(id);
        } else {
            this.checkedList.splice(this.checkedList.indexOf(id), 1);
        }
    }

    toggleCheckBox() {
        this.isChecked = !this.isChecked;
        if (this.isChecked == true) {
            this.checkedList = this.visas.map(function (a) {
                return a.visa_id;
            });
        } else {
            this.checkedList = [];
        }
    }

    resetCheckList() {
        this.isChecked = false;
        this.checkedList = [];
    }

    // onQuickUpdate(formData) {
    //   console.log(this.selectedVisa.visa_id);
    //   console.log(this.checkedList);
    //   console.log(formData);
    //   var data = {
    //     company_status_id: formData.value.company_status_id,
    //     company_quota: formData.value.company_quota,
    //     remarks: [{"company_remark": formData.value.company_remark}],
    //     priority_level: formData.value.priority_level,
    //     due_date: formData.value.due_date.formatted,
    //     stop_following: formData.value.stop_following,
    //     last_contacted_by: formData.value.last_contacted_by,
    //     last_contacted_at: formData.value.last_contacted_at.formatted
    //   };
    //
    //
    //
    //   this.apiService.update(this.node, ids, data)
    //       .subscribe((response) => {
    //             if (response.json().error == true) {
    //               alert('Unable to update visa');
    //             } else {
    //               this.getUsingQuery();
    //               this.isChecked = false;
    //               this.checkedList = [];
    //               alert('visa updated Successfully');
    //             }
    //           },
    //           (error) => alert('Unable to update visa')
    //       );
    // }

    clearData() {
        this.clear = '';
    }

    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }
}



// WEBPACK FOOTER //
// ./src/app/company-visa/company-visa.component.ts